import React, { PureComponent } from 'react';

import { toArray } from 'helpers/Array';
import { isString } from 'helpers/String';
import get from 'lodash/get';
import last from 'lodash/last';
import { FileService } from 'modules/file';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import AvatarDropzone from './AvatarDropzone';
import { ENTITY_TYPE } from './constants';

import { UploadManager } from '@hotmart/club-files-ui';

const UploadManagerWrapper = (props) => (
  <UploadManager
    entity={ENTITY_TYPE}
    {...props}
    onError={FileService.handleFileException}
    onCancelUpload={FileService.onCancelUpload}
    itemsProp="src"
  >
    <AvatarDropzone />
  </UploadManager>
);

export default class AvatarUpload extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    name: PropTypes.string
  };

  get src() {
    const { value } = this.props;

    if (isString(value)) {
      return [
        {
          id: value
        }
      ];
    }

    return toArray(value);
  }

  handleAvatarChange = (items) => {
    const { onChange, name } = this.props;
    const target = { name, value: get(last(items), 'id', null) };

    onChange && onChange({ target });
  };

  handleError = (message, data) => UiService.setAlertError(message, data);

  render() {
    return (
      <UploadManagerWrapper
        setCentralError={this.handleError}
        {...this.props}
        onItemsChange={this.handleAvatarChange}
        src={this.src}
      />
    );
  }
}
